import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/rafaelosorio/Documents/GitHub/cp4i-demohub/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const Title = () => <span>Automate customer interactions using APIs and Integration Demo</span>;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const FeatureCard = makeShortcode("FeatureCard");
const layoutProps = {
  Title,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <FeatureCard title="Automate customer interactions using APIs and Integration Demo" color="dark" mdxType="FeatureCard">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "33.33333333333333%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARASEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAHABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAQF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgD/2gAMAwEAAhADEAAAAbpA2UEf/8QAGBAAAwEBAAAAAAAAAAAAAAAAAgEDADH/2gAIAQEAAQUCBBJc1KIi/8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQMBAT8BSf/EABYRAAMAAAAAAAAAAAAAAAAAAAECEP/aAAgBAgEBPwFTP//EABoQAAICAwAAAAAAAAAAAAAAAAABEgIRMWH/2gAIAQEABj8CXS0dozE//8QAGhAAAgIDAAAAAAAAAAAAAAAAAREAIUFRYf/aAAgBAQABPyEfA3xAUYzE3H9jtT//2gAMAwEAAgADAAAAEH/f/8QAFhEBAQEAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/ECdn/8QAFhEBAQEAAAAAAAAAAAAAAAAAARAR/9oACAECAQE/EEwn/8QAGhABAAMBAQEAAAAAAAAAAAAAAREhADFhgf/aAAgBAQABPxCshikrQwk681k6kvms0UE9PhW//9k=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "banner",
          "title": "banner",
          "src": "/cp4i-demohub/static/c8a2a8b273a5880f3cb9787f3c60a10c/2e753/customer-service.jpg",
          "srcSet": ["/cp4i-demohub/static/c8a2a8b273a5880f3cb9787f3c60a10c/69549/customer-service.jpg 288w", "/cp4i-demohub/static/c8a2a8b273a5880f3cb9787f3c60a10c/473e3/customer-service.jpg 576w", "/cp4i-demohub/static/c8a2a8b273a5880f3cb9787f3c60a10c/2e753/customer-service.jpg 1152w", "/cp4i-demohub/static/c8a2a8b273a5880f3cb9787f3c60a10c/92dea/customer-service.jpg 1500w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </FeatureCard>
    <p><strong parentName="p">{`Demo Use Case`}</strong>{`: Access applications through APIs and Integrations`}</p>
    <p><strong parentName="p">{`Demo Description`}</strong>{`: Use Watson AI together with SaaS connectivity to Salesforce and ServiceNow to create a self-service car repair API giving customers real-time estimates and integrating directly with systems of record. The demo shows easy API creation with No-code App Connect Designer, rate limiting plans, security policies and Self-Service API consumption using the API Connect Portal`}</p>
    <p><strong parentName="p">{`Demo Capabilities`}</strong>{`: ACE Designer, ACE, APIC`}</p>
    <p><strong parentName="p">{`Demo Products`}</strong>{`: CP4I 2021.1 on ROKS 4.6`}</p>
    <p>{`Here you will be able to prepare yourself to deliver this demo. To deliver this demo, follow the steps below:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cp4i-demohub/salesdemos/carrepair-new/understand"
        }}>{`Understand the Demo`}</a>{`: Learn the Demo Scenario, check the Demo Video and review the Demo Sequence`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cp4i-demohub/salesdemos/carrepair-new/deliver"
        }}>{`Deliver the Demo`}</a>{`: Check the different delivery options and be ready to deliver the demo`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      